import { ref, watch, onMounted } from 'vue';
import { useUserStore } from '@/stores/UserStore';
import useSettingsGlobals from '@/composables/useSettingsGlobals'

const { $PLATFORM, $WEB_VIEW } = useSettingsGlobals()  

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

export default (initialValue, key, system = 'localStorage') => {
  if (system === 'off') return;
  
  const storageSystem = ref(system);
  const userStore = useUserStore();

  const returnValue = ref(initialValue)
  const loaded = ref(false)
  let storedValue;
  let unwatch;

  onMounted(async () => {
    
    if (storageSystem.value === 'localStorage') {
      // We use url params instead of localStorage for webviews
      // This does not apply to apiUserStorage
      if ($WEB_VIEW) {
        storedValue = JSON.stringify(initialValue)
      } else {
        storedValue = window.localStorage.getItem(key)
        loaded.value = true
      }
    }
    
    if (storageSystem.value === 'webViewMessenger') {
      storedValue = urlParams.get(key);
      loaded.value = true
    }
    
    if (storageSystem.value === 'apiUserStorage') {
      storedValue = await userStore.getAPIStorageItem(key);

      loaded.value = true
    }
    
    if (storedValue !== null && storedValue !== 'undefined') {
      try {
        returnValue.value = JSON.parse(storedValue)
      } catch (err) {
        if (err instanceof SyntaxError) {
          returnValue.value = storedValue // treat as plain string
        } else {
          throw err
        }
      }
    }
  
    unwatch = watch(
      returnValue,
      (val) => {
        if (storageSystem.value === 'localStorage' && !$WEB_VIEW) {
          window.localStorage.setItem(key, JSON.stringify(val))
        }
  
        if (storageSystem.value === 'webViewMessenger') {
          if ($PLATFORM === 'android') {
            const params = [key, val.toString()]
  
            alert(params.join(','))
          } else {
            const info = {
              type: key,
              value: val
            }
  
            window.webkit.messageHandlers.observe.postMessage(info)
          }
        }
  
        if (storageSystem.value === 'apiUserStorage') {
          userStore.updateAPIStorageItem(key, JSON.stringify(val))
        }
        
      },
      {
        deep: true
      }
    )
  })

  function updateStorageSystem(newSystem) {
    storageSystem.value = newSystem;
  }

  return [returnValue, loaded, unwatch, updateStorageSystem];
}